class ModiBanBanner extends HTMLElement {
    constructor() {
        super();
        this.data = this.fetchData();
        this.selectedOption = this.data.devices[0];
        this.options = this.querySelectorAll('.js-option');
        this.images = this.querySelectorAll('.js-image');
        this.heading = this.querySelector('.js-title');
        this.description = this.querySelector('.js-description');
        this.button = this.querySelector('.js-button');
        this.horizontalInfo = this.querySelector('.js-horizontal-info');
        this.verticalInfo = this.querySelector('.js-vertical-info');
        this.infoControl = this.querySelectorAll('.js-info-expand');

        this.options.forEach((option) => {
            option.addEventListener('click', this.handleOptionSwitch.bind(this))
        })

        this.addEventListener('click', (event) => {
            if (event.target.classList.contains('js-info-expand')) {
                this.handleInfoToggle(event)
            }
        })
    }

    // Required to escape the quotes for the JSON parse
    fetchData() {
        let jsonText = this.querySelector('.js-data').innerHTML;
        jsonText = jsonText.replace(/`([\s\S]*?)`/g, function (match, p1) {
            return '"' + p1.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"';
        });
        return JSON.parse(jsonText)
    }

    handleOptionSwitch(event) {
        const button = event.target;
        const id = parseInt(button.dataset.attr);
        this.selectedOption = this.data.devices.find((device) => device.id === id);
        this.options.forEach((option) => option.classList.toggle('modi-ban-banner__option--active', parseInt(option.dataset.attr) === id));
        this.reloadComponent();
    }

    handleInfoToggle(event) {
        const button = event.target;
        const container = button.closest('.modi-ban-banner__details-horizontal');
        const expand = container.querySelector('.js-info-content');

        if (expand.style.maxHeight) {
            expand.style.maxHeight = null;
        } else {
            expand.style.maxHeight = expand.scrollHeight + "px";
        }
    }

    generateInfo(orientation, option) {
        const container = document.createElement('div');
        const contentWrapper = document.createElement('div')
        const heading = document.createElement('p');
        const content = document.createElement('p');

        container.classList.add(`modi-ban-banner__details-${orientation}`);
        heading.classList.add('modi-ban-banner__details-title');
        if (this.data.icons.show_icon_dropdown == "true")
            content.classList.add(...['modi-ban-banner__details-expandable', 'js-info-content'])

        heading.innerHTML = option.heading;
        content.innerHTML = option.content;

        container.innerHTML = option.icon;
        contentWrapper.append(heading)
        contentWrapper.append(content)
        container.append(contentWrapper);
        if (this.data.icons.show_icon_dropdown == "true")
            container.innerHTML += this.data.icons.info;

        return container;
    }

    renderInfo() {
        this.horizontalInfo.innerHTML = "";
        this.verticalInfo.innerHTML = "";

        this.selectedOption.horizontal_data.forEach((data) => {
            if (!data.heading) return;
            this.horizontalInfo.append(this.generateInfo('horizontal', data))
        })
        this.selectedOption.vertical_data.forEach((data) => {
            if (!data.heading) return;
            this.verticalInfo.append(this.generateInfo('vertical', data))
        })
    }

    animate(callback) {
        this.heading.style.opacity = 0;
        this.description.style.opacity = 0;
        if (this.button)
            this.button.style.opacity = 0;
        this.horizontalInfo.style.opacity = 0;
        this.verticalInfo.style.opacity = 0;
        this.images.forEach((image) => image.style.opacity = 0);

        setTimeout(() => {
            callback();

            this.heading.style.opacity = 1;
            this.description.style.opacity = 1;
            if (this.button)
                this.button.style.opacity = 1;
            this.horizontalInfo.style.opacity = 1;
            this.verticalInfo.style.opacity = 1;
            this.images.forEach((image) => image.style.opacity = 1);
        }, 500);
    }

    reloadComponent() {
        this.animate(() => {
            if (this.heading)
                this.heading.innerHTML = this.selectedOption.title;
            if (this.description)
                this.description.innerHTML = this.selectedOption.description;

            if (this.button) {
                this.button.innerHTML = this.selectedOption.button.label;
                this.button.href = this.selectedOption.button.link;
            }

            this.images.forEach((image) => image.src = this.selectedOption.image);

            this.renderInfo();
        })
    }
}

customElements.define('modi-ban-banner', ModiBanBanner)
